import React, { useRef, useEffect } from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

// Import Component
import { SearchBlock } from '../svgs/SearchBlock'

const SearchInput = styled.input`
	border: none;
	border-bottom: 2px solid ${({ theme }) => theme.search.borderColor};
	color: ${({ theme, textColor }) => textColor || theme.colors.darkGrey};
	font-size: 28px;
	height: 60px;
	outline: none;
	width: 70%;
	background: transparent;

	${({ theme }) => theme.MQ.S} {
		max-width: 300px;
		width: 100%;
	}
`
const SearchSubmit = styled.button`
	border: none;
	cursor: pointer;
	display: inline-block;
	height: 60px;
	padding: 0;
	vertical-align: bottom;
	width: 60px;
`

SearchForm.propTypes = {
	color: string,
	queryString: string,
	redirectUrl: string,
}

export function SearchForm({ color, queryString, redirectUrl }) {
	const handleSearch = (event) => {
		event.preventDefault()
		const searchQuery = event.target.elements.query.value
		if (searchQuery) {
			return (window.location.href = queryString
				? `/search/?q=${searchQuery}${queryString}`
				: `/search/?q=${searchQuery}`)
		} else {
			return (window.location.href = redirectUrl ? redirectUrl : '/search/?q=Small+Business')
		}
	}

	const searchInputRef = useRef()

	useEffect(() => {
		searchInputRef.current.focus()
	}, [])

	return (
		<form onSubmit={handleSearch}>
			<SearchInput
				className="search-input"
				aria-label="Enter search term"
				name="query"
				type="text"
				textColor={color}
				ref={searchInputRef}
			/>
			<SearchSubmit aria-label="Search Button" type="submit">
				<SearchBlock />
			</SearchSubmit>
		</form>
	)
}
